import { styled } from '@linaria/react';
import NewsSearchListSkeleton from '@fe-news/components/molecules/NewsSearchList/NewsSearchListSkeleton';
import TimeAndSearchFilterSkeleton from '@fe-news/components/molecules/Member/TimeAndSearchFilterSkeleton';

const View = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  position: relative;
  margin-top: 24.5px;
`;

const PopTopicDetailInfiniteListSkeleton = () => {
  return (
    <View>
      <TimeAndSearchFilterSkeleton />
      <NewsSearchListSkeleton />
    </View>
  );
};

export default PopTopicDetailInfiniteListSkeleton;
